interface SkeletonTableProps {
  rows?: number;
  columns?: number;
  showCheckbox?: boolean;
  showAvatar?: boolean;
  className?: string;
}

/**
 * Skeleton loader for tables (e.g., ApprenantsListView)
 */
const SkeletonTable = ({
  rows = 5,
  columns = 6,
  showCheckbox = true,
  showAvatar = true,
  className = "",
}: SkeletonTableProps) => {
  return (
    <div className={`bg-white rounded-xl border border-gray-200 overflow-hidden ${className}`}>
      <table className="w-full">
        {/* Header */}
        <thead className="bg-gray-50 border-b border-gray-200">
          <tr>
            {showCheckbox && (
              <th className="w-10 p-4">
                <div className="w-4 h-4 bg-gray-200 rounded animate-pulse" />
              </th>
            )}
            {Array.from({ length: columns }).map((_, i) => (
              <th key={i} className="p-4 text-left">
                <div className="h-3 w-16 bg-gray-200 rounded animate-pulse" />
              </th>
            ))}
          </tr>
        </thead>

        {/* Body */}
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex} className="border-b border-gray-100">
              {showCheckbox && (
                <td className="p-4">
                  <div className="w-4 h-4 bg-gray-200 rounded animate-pulse" />
                </td>
              )}

              {/* Session count badge */}
              <td className="p-4">
                <div className="w-8 h-8 bg-gray-200 rounded-full animate-pulse" />
              </td>

              {/* Avatar */}
              {showAvatar && (
                <td className="p-4">
                  <div className="w-10 h-10 bg-gray-200 rounded-full animate-pulse" />
                </td>
              )}

              {/* Other columns */}
              {Array.from({ length: columns - (showAvatar ? 2 : 1) }).map((_, colIndex) => (
                <td key={colIndex} className="p-4">
                  <div
                    className="h-4 bg-gray-200 rounded animate-pulse"
                    style={{ width: `${60 + Math.random() * 40}%` }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SkeletonTable;
